export const PURCHASE_SCENARIO_OPTIONS = ['PTO', 'PTS', 'PTO-ZC']

export const PURCHASE_SCENARIO_SELECT_OPTIONS = PURCHASE_SCENARIO_OPTIONS.map((value) => ({
  label: value,
  value,
}))